/* Hero parallax (all viewports, damped) + featured-collection card stagger
   (desktop). Section reveal is handled by optimal-ios.js (iOS sheet system). */
(function () {
  var HERO_ID = 'shopify-section-slideshow_FDGjK8';
  var FEATURED_ID = 'shopify-section-featured_collection';
  var isMobile = window.matchMedia('(max-width: 768px)').matches;
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduced) return;

  // --- Hero parallax, damped so the image eases toward the scroll position
  //     instead of tracking it 1:1. Desktop only: on iOS it fights native
  //     momentum scrolling and reads as jank. ---
  var hero = document.getElementById(HERO_ID);
  var heroMedia = hero && !isMobile ? hero.querySelector('.banner__media') : null;
  if (heroMedia) {
    var FACTOR = 0.35;
    var EASE = 0.12;
    var current = window.scrollY * FACTOR;
    var raf = null;

    heroMedia.style.willChange = 'transform';
    heroMedia.style.transform = 'translateY(' + current + 'px)';

    var tick = function () {
      var target = window.scrollY * FACTOR;
      current += (target - current) * EASE;
      if (Math.abs(target - current) < 0.1) {
        current = target;
        raf = null;
      } else {
        raf = requestAnimationFrame(tick);
      }
      heroMedia.style.transform = 'translateY(' + current + 'px)';
    };

    window.addEventListener(
      'scroll',
      function () {
        if (!raf) raf = requestAnimationFrame(tick);
      },
      { passive: true }
    );
  }

  if (isMobile) return;

  // --- Featured collection: stagger cards individually ---
  var featuredSection = document.getElementById(FEATURED_ID);
  if (featuredSection) {
    var cards = featuredSection.querySelectorAll('.card-wrapper');
    cards.forEach(function (card, i) {
      card.style.opacity = '0';
      card.style.transform = 'translateY(50px)';
      card.style.transition = 'opacity 0.6s ease ' + i * 0.1 + 's, transform 0.6s ease ' + i * 0.1 + 's';
    });
    var cardObs = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.querySelectorAll('.card-wrapper').forEach(function (card) {
            card.style.opacity = '1';
            card.style.transform = 'translateY(0)';
          });
          cardObs.disconnect();
        });
      },
      { threshold: 0.05 }
    );
    cardObs.observe(featuredSection);
  }
})();
